// remove accents/diacritics and replace them inline
// courtesy of https://stackoverflow.com/a/37511463
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();const normalizeTextInput = (input: string): string => {
  return input.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export { normalizeTextInput };
